import React, { useState, useCallback } from 'react';
import checkIsIntegerNumber from 'common/utils/checkIsIntegerNumber';

export type TextFieldState = string;
export type HandleChangeTextFieldState = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => void;
export type SetTextFieldState = React.Dispatch<React.SetStateAction<string>>;
export type ResetTextFieldState = () => void;
type OnChangeCallback = (event: React.ChangeEvent<HTMLInputElement>) => void;
type TextFieldStateType = 'text' | 'int';
export interface TextFieldSettings {
  fieldType?: TextFieldStateType;
}

const checkIsFieldTypeText = (fieldType: TextFieldStateType) => (fieldType === 'text');
const checkIsFieldTypeNumber = (fieldType: TextFieldStateType) => (fieldType === 'int');

export const useTextFieldState = (
  initValue = '',
  onChangeCallback?: OnChangeCallback,
  settings?: TextFieldSettings
) => {
  const { fieldType = 'text' } = settings || {};
  const [value, setValue] = useState<TextFieldState>(() => initValue);

  const handleChangeValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { target: { value } } = event;
    if (
      checkIsFieldTypeText(fieldType)
      || (checkIsFieldTypeNumber(fieldType) && (value === '' || checkIsIntegerNumber(value)))
    ) setValue(value);
    if (onChangeCallback) onChangeCallback(event);
  }, [setValue, onChangeCallback, fieldType]);

  const resetValue = useCallback(() => {
    setValue(initValue);
  }, [setValue, initValue]);

  return [value, handleChangeValue, setValue, resetValue] as const;
};
